import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

export default function StepProgress({ steps, currentStep }) {
  const progressRef = useRef(null);
  const nodeRefs = useRef([]);
  const [railMetrics, setRailMetrics] = useState({ left: 0, width: 0 });

  useEffect(() => {
    const updateRailMetrics = () => {
      if (!progressRef.current || nodeRefs.current.length === 0) return;
      const containerRect = progressRef.current.getBoundingClientRect();
      const firstNode = nodeRefs.current[0];
      const lastNode = nodeRefs.current[nodeRefs.current.length - 1];
      if (!firstNode || !lastNode) return;
      const firstRect = firstNode.getBoundingClientRect();
      const lastRect = lastNode.getBoundingClientRect();
      const firstCenter = firstRect.left + firstRect.width / 2;
      const lastCenter = lastRect.left + lastRect.width / 2;
      const left = Math.max(0, firstCenter - containerRect.left);
      const width = Math.max(0, lastCenter - firstCenter);
      setRailMetrics({ left, width });
    };
    updateRailMetrics();
    window.addEventListener('resize', updateRailMetrics);
    return () => window.removeEventListener('resize', updateRailMetrics);
  }, [steps.length]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.6 }}
      className="relative mt-8 mb-8"
      ref={progressRef}
    >
      <div className="absolute top-5" style={{ left: railMetrics.left, width: railMetrics.width }}>
        <div className="h-0.5 bg-gray-200" />
        <div
          className="h-0.5 bg-emerald-500 transition-all duration-500 absolute left-0 top-0"
          style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
        />
      </div>
      <div className="flex relative justify-between items-center">
        {steps.map((step, index) => (
          <div key={step.id} className="flex flex-col flex-1 items-center">
            <div
              className={`relative z-10 flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                currentStep === step.id
                  ? 'bg-emerald-500 border-emerald-500 text-white'
                  : step.completed
                  ? 'bg-emerald-100 border-emerald-500 text-emerald-600'
                  : 'bg-gray-100 border-gray-300 text-gray-400'
              }`}
              ref={(el) => (nodeRefs.current[index] = el)}
            >
              <step.icon size={16} />
            </div>
            <div className="mt-2 text-center">
              <div className={`text-xs font-medium ${currentStep === step.id || step.completed ? 'text-emerald-600' : 'text-gray-400'}`}>
                {step.title}
              </div>
              {step.subtitle && <div className="text-xs text-gray-500">{step.subtitle}</div>}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}


